import React from 'react';
import './App.css';
import cloudImage from './cloud.png';

function App() {
  return (
    <div className="akatsuki-app">
      {/* 祥云图案背景 */}
      <div className="akatsuki-cloud-background">
        <div className="cloud-large">
          <img src={cloudImage} alt="祥云图案" />
        </div>
        <div className="cloud-medium">
          <img src={cloudImage} alt="祥云图案" />
        </div>
        <div className="cloud-small">
          <img src={cloudImage} alt="祥云图案" />
        </div>
        <div className="cloud-extra1">
          <img src={cloudImage} alt="祥云图案" />
        </div>
        <div className="cloud-extra2">
          <img src={cloudImage} alt="祥云图案" />
        </div>
      </div>
      
      {/* 晓组织主题头部 */}
      <header className="akatsuki-header">
        <div className="cloud-pattern"></div>
        <div className="akatsuki-title">
          <h1>Akatsuki Studio</h1>
          <p className="subtitle">Telegram 机器人定制 · 网站定制 · 开发搭建</p>
        </div>
      </header>

      <main className="akatsuki-main">
        {/* 工作室成员Telegram联系方式 */}
        <section className="members-section">
          <h2>工作室成员</h2>
          <p className="section-description">点击卡片跳转到Telegram</p>
          <div className="members-grid">
            {[
              { 
                name: '宇智波鼬', 
                role: '架构师', 
                color: '#B22222',
                telegram: '@uoduodihs',
                telegramUrl: 'https://t.me/uoduodihs',
                description: '系统设计'
              },
              { 
                name: '小南', 
                role: '产品经理', 
                color: '#4B0082',
                telegram: '@uoduodihs0',
                telegramUrl: 'https://t.me/uoduodihs0',
                description: '产品规划，用户需求分析'
              },
              { 
                name: '干柿鬼鲛', 
                role: '后端架构师', 
                color: '#006400',
                telegram: '@uoduodihs1',
                telegramUrl: 'https://t.me/uoduodihs1',
                description: '后端开发，服务运维'
              },
              { 
                name: '迪达拉', 
                role: 'UI/UX设计师', 
                color: '#DAA520',
                telegram: '@uoduodihs2',
                telegramUrl: 'https://t.me/uoduodihs2',
                description: '艺术就是爆炸！创意视觉设计'
              },
              // { 
              //   name: '蝎', 
              //   role: '运维工程师', 
              //   color: '#DC143C',
              //   telegram: '@uoduodihs3',
              //   telegramUrl: 'https://t.me/uoduodihs3',
              //   description: '服务器部署，系统监控与维护'
              // },
              // { 
              //   name: '佩恩', 
              //   role: '项目负责人', 
              //   color: '#8B0000',
              //   telegram: '@PainLeader',
              //   telegramUrl: 'https://t.me/PainLeader',
              //   description: '项目管理，团队协调'
              // },
            ].map((member, index) => (
              <div 
                key={index} 
                className="member-card" 
                style={{ borderColor: member.color }}
                onClick={() => window.open(member.telegramUrl, '_blank')}
              >
                <div className="member-icon" style={{ backgroundColor: member.color }}>
                  <span className="telegram-icon">✈️</span>
                </div>
                <h3>{member.name}</h3>
                <p className="member-role">{member.role}</p>
                <p className="member-description">{member.description}</p>
                <div className="telegram-username">
                  {member.telegram}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* 工作室介绍 */}
        <section className="studio-section">
          <h2>晓</h2>
          <div className="studio-info">
            <div className="studio-description">
              <p>我们是一支专注于前沿技术的工作室，以晓组织的名义聚集了各领域的精英。</p>
              <p>工作室秉承"技术改变世界"的理念，致力于打造卓越的数字产品。</p>
              <p>通过Telegram保持高效沟通，确保项目顺利进行。</p>
            </div>
            <div className="studio-contact">
              <h3>工作室公共频道</h3>
              <div className="public-channel">
                <div className="channel-info">
                  <span className="channel-name">@AkatsukiStudioUoduodihs</span>
                  <span className="channel-desc">技术分享 · 项目更新 · 行业资讯</span>
                </div>
                <button className="channel-button" onClick={() => window.open('https://t.me/AkatsukiStudioUoduodihs', '_blank')}>
                  加入频道
                </button>
              </div>
              <div className="contact-methods">
                <div className="contact-item">
                  <span className="contact-icon">📧</span>
                  <span>邮箱: uoduodihs@gmail.com</span>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">🌐</span>
                  <span>网站: https://uoduodihs.com</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="akatsuki-footer">
        <div className="footer-content">
          <p>© 2026 Akatsuki Studio  · 一切为了和平</p>
          <p className="footer-note">知晓一切</p>
        </div>
        <div className="cloud-pattern-bottom"></div>
      </footer>
    </div>
  );
}

export default App;
